const config = {
  url: '/tutorials',
  title: 'Учебные пособия',
  endpoint: '/admin-search?filter=tutorials',
  type: 'table',
  getUrl: id => `/tutorial/${id}`,
  getApiUrl: id => `/tutorials/${id}`,
  search: true,
  key: 'tutorials',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'title',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.title,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 500,
        required: true,
      },
    },
    {
      key: 'short_title',
      width: 150,
      title: 'Короткое название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.short_title,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 100,
        required: true,
      },
    },
    {
      key: 'tutorial_type_id',
      width: 150,
      title: 'Тип',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.tutorial_types_name,
      edit: {
        component: 'DynamicSelect',
        endpoint: '/admin-search?filter=tutorial_types&sort[field]=name&sort[type]=asc&limit=100',
        disableFilterByValue: true,
        filter: 'tutorial_types',
        key: 'tutorial_type_id',
        keyName: 'tutorial_types_name',
        placeholder: 'Выберите',
        search: true,
        mode: 'single',
        getOptionValue: data => data.name,
        required: true,
      }
    },
  ],
  filters: [],
}

export default config
